import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

export default function useRevealText(dependency) {
    useEffect(() => {
        if (!dependency) return;

        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll(".reveal-type");

        elements.forEach((el) => {
            const split = new SplitType(el, { types: "chars" });

            gsap.fromTo(
                split.chars,
                { color: el.dataset.bgColor },
                {
                    color: el.dataset.fgColor,
                    stagger: 0.02,
                    scrollTrigger: {
                        trigger: el,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,
                    },
                }
            );
        });

        return () => ScrollTrigger.getAll().forEach((t) => t.kill());
    }, [dependency]);
}
